import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import type {
  ChartData,
  ChartOptions
} from 'chart.js'
import {
  Bar
} from 'react-chartjs-2'
import {
  color
} from '../../../styles'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

interface BarChartInterface {
  options: ChartOptions<'bar'>,
  data: ChartData<'bar'>
  showLegend: boolean,
  height: string | number,
  width: string | number
}

export const ChartBarVertical: React.FC<BarChartInterface> = ({
  data,
  options,
  showLegend = true,
  ...props
}) => {
  const colorData = [
    color.colorPrimary,
    '#cd0055',
    color.colorDanger,
    '#e64b1d',
    '#ed6914',
    color.colorWarning,
    '#bc9e00',
    '#869806',
    color.colorSuccess,
    '#009a98',
    color.colorInfo,
    '#0073b9',
  ]

  return (
    <>
      <Bar 
        {...props}
        data={{
          labels: data.labels,
          datasets: data.datasets.map((val, i) => ({
            ...val,
            backgroundColor: val?.backgroundColor ? val.backgroundColor : i > 12 ? colorData[Math.round(colorData.length / i)] : [colorData[i]],
            borderWidth: val.borderWidth ? val.borderWidth : 1
          }))
        }}
        options={{
          ...options,
          backgroundColor: options?.backgroundColor ? options.backgroundColor : color.colorPrimary,
          plugins: {
            ...options?.plugins,
            legend: {
              ...options?.plugins?.legend,
              display: showLegend,
            }
          }
        }}
      />
    </>
  )
}
